export default __webpack_public_path__ + "static/media/komedy.5ea6b671.jpg";